import type { IntlService } from '@app/services/IntlService'

import { createThunk } from '@app/store/thunk'

export function getIntlService() {
  return createThunk((_dispatch, _getState, context) => context.lookupEnsure<IntlService>(IntlServiceSymbol))
}
export function setIntlService(value: IntlService) {
  return createThunk((_dispatch, _getState, context) => context.getRootContext().set(IntlServiceSymbol, value))
}

const IntlServiceSymbol = Symbol('IntlService')
